import React, { useContext, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SimpleImageCarousel from "../settings/imagecarusel";
import { WiTime4 } from "react-icons/wi";
import { RxAvatar } from "react-icons/rx";
import check from "../photos/checkmarkround.png";
import xcircle from "../photos/xcircle.png";
import { LanguageContext } from "../settings/LanguageContext";
import { toursData } from "./turstranslations";
import emailjs from "@emailjs/browser";
import "./turpackage.css";
import { RxDropdownMenu } from "react-icons/rx";


export default function TourPage() {
  const { id } = useParams();
  const tour = toursData.find(t => t.id === id);
  const { lang } = useContext(LanguageContext);
  const formRef = useRef(null);

  // Store selected range as string
  const [selectedRange, setSelectedRange] = useState(tour?.peoplePrices[0].range || "");
  const [showDropdown, setShowDropdown] = useState(false);

  if (!tour) return <p>Tour not found</p>;

  const text = tour.translations[lang];

  // Convert selectedRange to number for price calculation
  const num = selectedRange.includes("+")
    ? parseInt(selectedRange)
    : parseInt(selectedRange.split("-")[0]);

  const priceObj = tour.peoplePrices.find(p => {
    if (p.range.includes("+")) {
      return num >= parseInt(p.range);
    } else {
      const [min, max] = p.range.split("-").map(Number);
      return num >= min && num <= max;
    }
  });

  const price = priceObj ? priceObj.price : "Contact for price";

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      "YOUR_SERVICE_ID",
      "YOUR_TOUR_TEMPLATE_ID",
      formRef.current,
      "YOUR_PUBLIC_KEY"
    ).then(() => {
      alert(lang === "EN" ? "Request sent!" : "Запрос отправлен!");
      formRef.current.reset();
    }, (error) => {
      console.error(error);
      alert(lang === "EN" ? "Failed to send request" : "Ошибка отправки");
    });
  };

  return (
    <div className="tour-page">
      <div className="tour-card">
        <div className="tour-image-section">
          <SimpleImageCarousel images={tour.images} />
          <div className="tour-badges">
            <span className="badge">
              <WiTime4 /> {tour.hours}
            </span>

            {/* People badge with dropdown */}
            <span
              className="badge"
              onClick={() => setShowDropdown(!showDropdown)}
              style={{ cursor: "pointer", position: "relative" }}
            >
              <RxAvatar /> {selectedRange}  <RxDropdownMenu />

              {showDropdown && (
                <ul
                  className="people-dropdown"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    background: "#fff",
                    border: "1px solid #ccc",
                    padding: 0,
                    margin: 0,
                    listStyle: "none",
                    width: "100px",
                    zIndex: 1000,
                  }}
                >
                  {tour.peoplePrices.map((p, idx) => (
                    <li
                      key={idx}
                      style={{ padding: "5px", cursor: "pointer" }}
                      onClick={() => {
                        setSelectedRange(p.range); // Store full range string
                        setShowDropdown(false);
                      }}
                    >
                      {p.range}
                    </li>
                  ))}
                </ul>
              )}
            </span>
          </div>
        </div>

        <div className="tour-form-section">
          <h1>{text.name}</h1>
          <div className="price">
            {lang === "EN" ? "Price: " : "Цена: "} {price} USD
          </div>

          {/* EMAILJS FORM */}
          <form ref={formRef} onSubmit={sendEmail} className="tour-form">
            <input type="hidden" name="tour_name" value={text.name} />
            <input type="text"
              name="user_name"
              placeholder={lang === "EN" ? "Your name" : "Ваше имя"}
              required
            />
            <input type="tel"
              name="user_phone"
              placeholder={lang === "EN" ? "Phone number" : "Номер телефона"}
              required
            />
            <input type="email"
              name="user_email"
              placeholder={lang === "EN" ? "Email" : "Эл. почта"}
              required
            />
            <br />
            <button type="submit" className="primary-btn">
              {lang === "EN" ? "Request Tour" : "Запросить тур"}
            </button>
          </form>
        </div>
      </div>

      <div className="tour-content">
        <section>
          <h2>{text.overviewTitle}</h2>
          <p>{text.overviewText}</p>
        </section>
        <section>
          <h3>{text.Title1}</h3>
          <p>{text.Text1}</p>
        </section>
        <section>
          <h3>{text.Title2}</h3>
          <p>{text.Text2}</p>
        </section>
        <section>
          <h3>{text.Title3}</h3>
          <p>{text.Text3}</p>
        </section>
        <section>
          <h3>{text.Title4}</h3>
          <p>{text.Text4}</p>
        </section>
        <section>
          <h3>{text.Title5}</h3>
          <p>{text.Text5}</p>
        </section>
        <section>
          <h3>{text.Title6}</h3>
          <p>{text.Text6}</p>
        </section>
        <section>
          <h3>{text.Title7}</h3>
          <p>{text.Text7}</p>
        </section>

        <section className="tour-lists">
          <div className="inclusions">
            <h2>{text.inclusionsTitle}</h2>
            <ul>
              {text.inclusionsList.map((item, idx) => (
                <li key={idx}>
                  <img src={check} alt="" /> {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="excluded">
            <h2>{text.excludedTitle}</h2>
            <ul>
              {text.excludedList.map((item, idx) => (
                <li key={idx}>
                  <img src={xcircle} alt="" /> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}